import { FC, useCallback } from 'react';
import { Box } from '@mui/material';
import { AppOwnerRoleType } from 'common-types';
import UserName from '../../../elements/UsernName/UserName';
import AddOwnerButtonContainer from '../../containers/AddOwnerButtonContainer';
import { Owner } from '../../applications-types';
import { updateAppOwnerEditRequest } from '../../../application-owners/api/applications-owners-api';

const OwnersList: FC<React.PropsWithChildren<OwnersProps>> = ({
  type,
  owners,
  onAddOwners,
}) => {
  const handleAddOwners = useCallback(() => {
    updateAppOwnerEditRequest('role', type);
    onAddOwners && onAddOwners();
  }, [onAddOwners, type]);

  if (!owners || owners.length === 0) {
    return <AddOwnerButtonContainer onAddOwners={handleAddOwners} />;
  }

  return (
    <Box display='flex' flexDirection='column' gap={1}>
      {owners.map(owner => (
        <UserName key={owner.name} name={owner.name} />
      ))}
    </Box>
  );
};

export interface OwnersProps {
  onAddOwners: () => void;
  owners?: Owner[];
  type: AppOwnerRoleType;
}

export default OwnersList;
